var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32145 0.344468C5.48535 0.00043316 4.5661 -0.0883848 3.6796 0.0892085C2.79309 0.266802 1.979 0.702858 1.33993 1.34241C0.700867 1.98197 0.265435 2.79639 0.0885207 3.68304C-0.0883935 4.56968 0.00112914 5.48885 0.345804 6.3247L32.3991 84.1684C32.7424 85.0024 33.3243 85.7164 34.0719 86.221C34.8194 86.7255 35.6993 86.9981 36.6012 87.0044C37.5031 87.0108 38.3867 86.7507 39.1413 86.2567C39.8959 85.7628 40.4878 85.057 40.8428 84.2279L53.1376 55.5402C53.6007 54.4601 54.4614 53.5994 55.5416 53.1362L84.2293 40.8415C85.0583 40.4865 85.7641 39.8946 86.2581 39.14C86.752 38.3854 87.0121 37.5017 87.0058 36.5998C86.9994 35.698 86.7269 34.8181 86.2223 34.0705C85.7178 33.323 85.0037 32.741 84.1697 32.3978L6.32145 0.344468Z",
    fill: "#C8F22B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ad04bb433b7f06023848d112db21f602.svg";
export { ForwardRef as ReactComponent };